(function(){
  var progress=document.getElementById('progress'); var sticky=document.getElementById('sticky'); var reveal=document.getElementById('reveal'); var offer=document.getElementById('offer');
  var fired=new Set(); window.dataLayer=window.dataLayer||[];
  function track(event,detail){try{window.dataLayer.push(Object.assign({event:event},detail||{}));}catch(e){}}
  function update(){
    var d=document.documentElement; var max=d.scrollHeight-window.innerHeight; var pct=max>0?(window.scrollY/max)*100:0; if(progress){progress.style.width=pct+'%';}
    [25,50,75,90].forEach(function(x){if(pct>=x&&!fired.has(x)){fired.add(x);track('advertorial_scroll',{depth:x});}});
    if(reveal){
      var revealTop=reveal.getBoundingClientRect().top;
      if(sticky){var show=revealTop<window.innerHeight*.44&&(!offer||offer.getBoundingClientRect().top>100);sticky.classList.toggle('show',show);}
      if(revealTop<window.innerHeight*.65&&!fired.has('reveal')){fired.add('reveal');track('advertorial_product_reveal');}
    }
  }
  try{
    var allowed={utm_source:1,utm_medium:1,utm_campaign:1,utm_content:1,utm_term:1,fbclid:1,gclid:1,gbraid:1,wbraid:1,ttclid:1,msclkid:1};
    var incoming=new URLSearchParams(location.search);
    var forwarded=[];
    incoming.forEach(function(v,k){if(allowed[k.toLowerCase()]){forwarded.push([k,v]);}});
    if(forwarded.length){
      document.querySelectorAll('[data-cta-location]').forEach(function(a){
        try{
          var u=new URL(a.href); var appended={};
          forwarded.forEach(function(pair){
            var k=pair[0],v=pair[1];
            if(u.searchParams.has(k)||appended[k]){return;}
            u.searchParams.append(k,v); appended[k]=1;
          });
          a.href=u.toString();
        }catch(e){}
      });
    }
  }catch(e){}
  document.querySelectorAll('[data-cta-location]').forEach(function(a){a.addEventListener('click',function(){track('advertorial_cta_click',{location:a.dataset.ctaLocation,href:a.href});});});
  addEventListener('scroll',update,{passive:true}); addEventListener('resize',update,{passive:true}); update();
})();
